import React from 'react';
import {
  Container, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Box, Button, TextField, Chip, Grid, Card,
  CardContent,
  Avatar,
  Stack, IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Select, MenuItem,
} from '@mui/material';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import defaultAvatar from '../assets/images/dashboard-home-page-image.png';


const FlyProItem = ({ item, startDate, endDate }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        mb: 2,
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        cursor: "pointer",
        borderRadius: '20px',
        border: '1px solid #B3BEC5',
        background: '#F6F6F6'
      }}
    >
      <CardContent sx={{ display: "flex", alignItems: "center", padding: '8px !important' }}>
        {/* Avatar */}
        <Avatar src={item.media[0]?.original_url || defaultAvatar} sx={{
          width: 56, height: 56, mr: 2,
          borderRadius: '20px',
        }} />

        {/* Content */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ fontSize: '11px', fontWeight: '500' }}>
            {startDate} &nbsp; {endDate}
          </Typography>
          <Typography variant="subtitle1" fontWeight="400" fontSize="18px" textAlign="left">
            {item.extra.full_name}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 0.5 }} flexWrap="wrap">
            <Typography variant="caption" color="#B3BEC5">
              Distance 10km
            </Typography>
            <Typography variant="caption" color="#B3BEC5">
              | Clients 102
            </Typography>
            <Typography variant="caption" color="#B3BEC5">
              | Rating ⭐ {item.extra.rating}
            </Typography>
          </Stack>
        </Box>

        {/* Arrow Icon */}
        <IconButton size="small">
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      </CardContent>
    </Card>
  );
};

export default FlyProItem;